import React from 'react'
import { imageUrl } from '../lib/images'
import SeoHead from '../components/SeoHead'
import WaveDivider from '../components/WaveDivider'
import { localizeTree } from '../i18n/localizeTree'

const RETAILERS = [
  {
    name: 'Fanø Blomster',
    address: 'Hovedgaden 75',
    city: '6720 Fanø',
    country: 'Danmark',
    phone: '75162656',
    email: 'butik@fano-blomster.dk',
    logo: '/_assets/fanoe-blomster.png',
  },
  {
    name: 'Sønderho Kro',
    address: 'Kropladsen 11',
    city: '6720 Fanø',
    country: 'Danmark',
    phone: '75164009',
    email: 'mail@sonderhokro.dk',
    logo: '/_assets/soenderho-kro.png',
  },
  {
    name: 'Slik for Voksne',
    address: 'Kongensgade 100',
    city: '6700 Esbjerg',
    country: 'Danmark',
    phone: '75451099',
    email: 'info@slikforvoksne.dk',
    logo: '/_assets/logo-slikforvoksne.png',
  },
  {
    name: 'Sønderho Gårdbutik',
    address: 'Vester Storetoft 67',
    city: '6720 Fanø',
    country: 'Danmark',
    phone: '50932362',
    email: 'info@sonderhogaardbutik.dk',
    logo: '/_assets/soenderho-gaardbutik.png',
  },
  {
    name: 'Arnbjerg pavillionen',
    address: 'Arnbjerg alle 2',
    city: '6800 Varde',
    country: 'Danmark',
    website: 'http://www.arnbjergpavillionen.dk/',
    logo: '/_assets/arnbjerg-pavillionen-thumb.png',
  },
  {
    name: 'A Place to Esbjerg',
    address: 'Grådybet 73 a',
    city: '6700 Esbjerg',
    country: 'Danmark',
    website: 'http://www.aplacetoesbjerg.dk/',
    logo: '/_assets/a-place-to-thumb.png',
  },
  {
    name: 'Vinhuset TopWine',
    address: 'Malervej 8',
    city: '6710 Esbjerg V',
    country: 'Danmark',
    website: 'http://www.vinhuset-topwine.dk/',
    logo: '/_assets/topwinethumb.png',
  },
  {
    name: 'Slusen Højer',
    address: 'Slusevej 10',
    city: '6280 Højer',
    country: 'Danmark',
    logo: '/_assets/slus-thumb.png',
  },
  {
    name: 'Butik og cafe Dyreborg',
    address: 'Gl. Guldagervej 3',
    city: '6710 Esbjerg V',
    country: 'Danmark',
    phone: '31317793',
    website: 'http://www.butikkendyreborg.dk/',
    logo: '/_assets/dyreborg-thump.png',
  },
  {
    name: 'Rikke Sandford',
    address: 'Hovedegaden 58B',
    city: '6720 Fanø',
    country: 'Danmark',
    phone: '25478766',
    website: 'http://rikkesandford.dk/',
    logo: '/_assets/rjlogo.png',
  },
  {
    name: 'Kaffebar Bean Machine',
    address: 'Kronprinsensgade 99',
    city: '6700 Esbjerg',
    country: 'Danmark',
    phone: '20637828',
    email: 'hej@beanmachine.dk',
    logo: '/_assets/hvid-transparent-480x96-1.png',
  },
]

export default function ForhandlerlistePage({ lang = 'da' }) {
  return localizeTree((
    <>
      <SeoHead pageId="retailers" lang="da" />

      {/* Header Banner */}
      <section className="subpage-hero bg-[#F7ECEE] py-12 sm:py-16 border-b border-[#C68D94]/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-script text-5xl sm:text-6xl text-[#3E3435] font-normal my-3">
            Find mig også hos disse forhandler
          </h1>
          <WaveDivider className="text-[#C68D94]/50 mx-auto mb-6" />
          <p className="text-xs sm:text-sm text-[#3E3435]/80 font-light leading-relaxed max-w-xl mx-auto">
            Her kan du finde et udvalg af Fanø Chokolades håndlavede produkter hos vores gode samarbejdspartnere på Fanø, i Esbjerg og omegn.
          </p>
        </div>
      </section>

      {/* Retailers Grid */}
      <section className="py-14 sm:py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-8">
          {RETAILERS.map((retailer, idx) => (
            <div
              key={idx}
              className={`col-span-12 ${RETAILERS.length % 2 === 1 && idx === RETAILERS.length - 1 ? 'sm:col-span-12' : 'sm:col-span-6'} ${RETAILERS.length % 3 !== 0 && idx >= RETAILERS.length - (RETAILERS.length % 3) ? (RETAILERS.length % 3 === 1 ? 'lg:col-span-12' : 'lg:col-span-6') : 'lg:col-span-4'} bg-white rounded-3xl p-7 border border-[#C68D94]/20 shadow-sm flex flex-col justify-between`}
            >
              <div>
                {/* Logo area */}
                <div className="h-28 rounded-2xl bg-[#FDF8F7] flex items-center justify-center p-4 mb-6 border border-[#C68D94]/15">
                  <img
                    src={imageUrl(retailer.logo, 'width=400,quality=90,format=auto')}
                    alt={retailer.name}
                    className="max-h-full max-w-full object-contain"
                    loading="lazy"
                  />
                </div>

                <h3 className="font-bold text-base sm:text-lg text-[#3E3435] mb-2">
                  {retailer.name}
                </h3>

                <div className="text-xs sm:text-sm text-[#3E3435]/80 font-light space-y-1 leading-relaxed">
                  <p>{retailer.address}</p>
                  <p>{retailer.city}</p>
                  <p>{retailer.country}</p>
                </div>
              </div>

              {/* Contact details */}
              <div className="mt-6 pt-4 text-xs text-[#3E3435]/90 space-y-1.5 font-light">
                {retailer.phone && (
                  <p>
                    <span className="font-medium text-[#3E3435]">Tlf: </span>
                    <a
                      href={`tel:${retailer.phone}`}
                      className="text-[#A35D67] hover:underline font-medium whitespace-nowrap"
                    >
                      {retailer.phone}
                    </a>
                  </p>
                )}

                {retailer.email && (
                  <p>
                    <a
                      href={`mailto:${retailer.email}`}
                      className="text-[#A35D67] hover:underline break-all whitespace-nowrap"
                    >
                      {retailer.email}
                    </a>
                  </p>
                )}

                {retailer.website && (
                  <p>
                    <a
                      href={retailer.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#A35D67] hover:underline flex items-center gap-1.5 pt-1"
                    >
                      <span>Besøg hjemmeside</span>
                      <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true" />
                    </a>
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  ), lang)
}
